export function cleanupBusinessTypeName(name: string): string {
  if (name.toLowerCase().endsWith(" business")) {
    return name.slice(0, -9);
  }

  return name;
}
